import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';
import { SR_API_ACTION_APARTMENT_LOCATOR_GET_LEADS_LEASE_STATS } from 'api/actionTypes';

export default async function getCurrentMonthLeaseStats(
  { state, apiClient },
  { apartmentLocatorUserId, currentMonthDateRange = null },
) {
  if (!currentMonthDateRange) {
    currentMonthDateRange = [
      momentWithAustinTimezone().startOf('month').toISOString(),
      momentWithAustinTimezone().endOf('month').toISOString(),
    ];
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_APARTMENT_LOCATOR_GET_LEADS_LEASE_STATS,
    queryId: String(apartmentLocatorUserId),
    state: state,
    payload: {
      apartmentLocatorUserId: apartmentLocatorUserId,
      dateRange: currentMonthDateRange,
    },
    onSuccess(monthToDateStats) {
      state.set(['apartmentLocator', 'monthToDateStats'], monthToDateStats);
    },
  });
}
